const STATE_COLORS: Record<string, { bg: string; text: string }> = {
  AC: { bg: "bg-green-100", text: "text-green-800" },
  AL: { bg: "bg-blue-100", text: "text-blue-800" },
  AM: { bg: "bg-emerald-100", text: "text-emerald-800" },
  AP: { bg: "bg-teal-100", text: "text-teal-800" },
  BA: { bg: "bg-red-100", text: "text-red-800" },
  CE: { bg: "bg-orange-100", text: "text-orange-800" },
  DF: { bg: "bg-indigo-100", text: "text-indigo-800" },
  ES: { bg: "bg-sky-100", text: "text-sky-800" },
  GO: { bg: "bg-emerald-100", text: "text-emerald-800" },
  MA: { bg: "bg-rose-100", text: "text-rose-800" },
  MG: { bg: "bg-amber-100", text: "text-amber-800" },
  MS: { bg: "bg-lime-100", text: "text-lime-800" },
  MT: { bg: "bg-yellow-100", text: "text-yellow-800" },
  PA: { bg: "bg-cyan-100", text: "text-cyan-800" },
  PB: { bg: "bg-red-100", text: "text-red-800" },
  PE: { bg: "bg-blue-100", text: "text-blue-800" },
  PI: { bg: "bg-green-100", text: "text-green-800" },
  PR: { bg: "bg-red-100", text: "text-red-800" },
  RJ: { bg: "bg-orange-100", text: "text-orange-800" },
  RN: { bg: "bg-emerald-100", text: "text-emerald-800" },
  RO: { bg: "bg-teal-100", text: "text-teal-800" },
  RR: { bg: "bg-sky-100", text: "text-sky-800" },
  RS: { bg: "bg-violet-100", text: "text-violet-800" },
  SC: { bg: "bg-pink-100", text: "text-pink-800" },
  SE: { bg: "bg-fuchsia-100", text: "text-fuchsia-800" },
  SP: { bg: "bg-red-100", text: "text-red-800" },
  TO: { bg: "bg-amber-100", text: "text-amber-800" },
};

interface StateBadgeProps {
  uf: string;
  className?: string;
}

export function StateBadge({ uf, className = "" }: StateBadgeProps) {
  const upper = (uf ?? "").toUpperCase().trim();
  const colors = STATE_COLORS[upper] ?? { bg: "bg-gray-100", text: "text-gray-700" };

  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold ${colors.bg} ${colors.text} ${className}`}
    >
      <span className="w-3 h-3 rounded-full border border-current/20 flex items-center justify-center text-[8px] font-bold">
        {upper.charAt(0)}
      </span>
      {upper}
    </span>
  );
}
